import axios from 'axios'

const mainUrl = process.env.VUE_APP_API_URL || 'https://jb.webdgroup.com/'
const localApiPattern = /localhost|127\.0\.0\.1|\[::1\]|0\.0\.0\.0|host\.docker\.internal/

if (process.env.NODE_ENV === 'production' && localApiPattern.test(mainUrl)) {
  throw new Error('VUE_APP_API_URL no puede apuntar a localhost en produccion')
}

const axiosC = axios.create({
  baseURL: `${mainUrl}`,
  timeout: 240000,
})


export {
    axiosC,
    mainUrl
  }
